import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within AdminProvider');
  }
  return context;
};

// Axios instance with auth interceptor
export const adminApi = axios.create({ baseURL: `${BACKEND_URL}/api/admin` });

export const AdminProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = localStorage.getItem('admin_token');
    const adminData = localStorage.getItem('admin_user');
    if (savedToken && adminData) {
      setToken(savedToken);
      setIsAuthenticated(true);
      setAdminUser(JSON.parse(adminData));
      adminApi.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
    }
  }, []);

  const login = async (username, password, recaptchaToken) => {
    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, { username, password, recaptcha_token: recaptchaToken || '' });
      const { token: newToken, username: uname, role } = response.data;
      const user = { username: uname, role };
      localStorage.setItem('admin_token', newToken);
      localStorage.setItem('admin_user', JSON.stringify(user));
      setToken(newToken);
      setIsAuthenticated(true);
      setAdminUser(user);
      adminApi.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      return true;
    } catch {
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    delete adminApi.defaults.headers.common['Authorization'];
    setToken(null);
    setIsAuthenticated(false);
    setAdminUser(null);
  };

  return (
    <AdminContext.Provider value={{ isAuthenticated, adminUser, token, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
};
